import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Whiteboard from "@/views/Whiteboard.vue";

Vue.use(VueRouter);

export enum Routes {
  Whiteboard = "Whiteboard",
  Playback = "Playback",
  TextEditorTest = "TextEditorTest",
}

const routes: Array<RouteConfig> = [
  {
    path: "/whiteboard/:wbid",
    name: Routes.Whiteboard,
    props: (route) => ({ wbid: route.params.wbid, config: window.wbconfig }),
    component: Whiteboard,
    // This used to be split into a separate bundle, but it's pretty pointless
    // since we only run this JS on one page
    // import(/* webpackChunkName: "whiteboard" */ "../views/Whiteboard.vue"),
  },
];

export const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});
